import "./Header.css";

function Header() {

    return (
        <div data-testid="Header" className="Header text-center text-dark bg-light pb-3">
            Key_Blogger
        </div>
    );
}

export default Header;